import { __awaiter } from "tslib";
import { resolveConfig, } from '@office-start/config-resolver-service';
export function executeM365AppsConfigDataFlow(options) {
    return __awaiter(this, void 0, void 0, function* () {
        const m365AppsConfig = yield resolveConfig('m365AppsData', options);
        return m365AppsConfig;
    });
}
//# sourceMappingURL=executeM365AppsConfigDataFlow.js.map